<script lang="ts">
export default {
    name: 'BaseSteps',
};
</script>

<script setup lang="ts">
import { computed, provide, ref } from 'vue';
import { DIRECTIONS } from '@/components/base-components/utils/direction';
import { Direction } from '@/components/base-components/types/direction';
import { BaseSteps } from '@/components/base-components/components/steps/context';

const props = withDefaults(defineProps<{
    active?: number;
    centered?: boolean;
    marker?: boolean;
    direction?: Direction;
}>(), {
    direction: DIRECTIONS.HORIZONTAL,
    active: -1,
});

const steps = ref([]);

const active = computed(() => props.active);
const centered = computed(() => props.centered);
const marker = computed(() => props.marker);
const direction = computed(() => props.direction);

provide(BaseSteps, {
    steps,
    active,
    marker,
    centered,
    direction,
});
</script>

<template>
    <div
        class="relative flex gap-2"
        :class="[
            {
                'flex-col': direction === DIRECTIONS.VERTICAL,
            }
        ]"
    >
        <slot />
    </div>
</template>
